import { ReactNode, forwardRef, ForwardRefRenderFunction } from 'react';
import { Input, InputProps, InputRef } from 'antd';
import { IconClose, IconSearch } from '@/components/Icons';
import cls from 'classnames';
import styles from './index.module.less';

export type SearchInputRef = InputRef;

interface Props extends InputProps {
  /** 自定义前缀icon */
  prefixIcon?: ReactNode;
  /** 容器的类名 */
  outerClassName?: string;
  /** 监听onEnter */
  onEnter?: () => void;
  /** 是否为带上边框样式，当前搜索框有三种样式，一种是带圆边框，一种是仅有下划线，还有一种是无边框 */
  type?: 'border' | 'no-border' | 'no-border-radius';
  isMobile?: boolean;
}

const SearchInput: ForwardRefRenderFunction<InputRef, Props> = (
  { onChange, prefixIcon, onEnter, outerClassName = '', type, isMobile, ...rest },
  ref
) => {
  return (
    <div
      className={cls({
        [styles.rewriteAntdInput]: true,
        [styles.border]: type === 'border',
        [styles.noBorder]: type === 'no-border',
        [styles.borderRadius]: type === 'no-border-radius',
        [outerClassName]: true,
      })}
    >
      <Input
        ref={ref}
        type='text'
        onPressEnter={(event) => {
          // isComposing判断当前状态是否为输入法输入中
          if (event.nativeEvent.isComposing || !onEnter) return;
          onEnter();
        }}
        onChange={onChange}
        prefix={prefixIcon || <IconSearch size={isMobile ? 24 : 32} />}
        className={styles.searchInput}
        allowClear={{
          clearIcon: <IconClose className={styles.hoverIcon} />,
        }}
        {...rest}
      />
    </div>
  );
};

export default forwardRef(SearchInput);
